
/**
 * Check to see if all values in a given object are null, or undefined or ''
 * @param obj 
 */
export const isAllEmptyVals = (obj: Object): boolean => {
  return !Object.values(obj).some(element => (element != null && element !== ''));
}
